<template>
  <div>

    <vue-topprogress ref="loadingProgress"></vue-topprogress>

    <div v-if="!loading">

      <h1 class="display-4 font-weight-lighter">
        Knowledgebase / FAQ
      </h1>

      <br />

      <c-row>
        <c-col col="4" v-for="(thread) in threads" class="mb-4">
          <div class="bg-dark p-4 library-card">
            <h3 class="font-weight-bold">{{ thread.title }}</h3>
            <p>{{ thread.body }}</p>
            <c-button size="sm" class="btn-sf btn-square" :to="'/tools/faq/'+thread.id"><i class="fal fa-plus"></i> Discuss</c-button>
            <img src="img/brand/sf-logo-mini-white.svg" width="30" class="float-right">
          </div>
        </c-col>
        <c-col col="4">
          <div class="bg-dark p-4 library-card" v-if="!this.$store.getters.isAdmin">
            <h3 class="font-weight-bold">Have a question or a topic of discussion?</h3>
            <p>If you have a question you would like to ask SuperForm Products click the link below.</p>
            <c-button size="sm" class="btn-sf btn-square" v-b-modal.thread-ticket><i class="fal fa-plus"></i> Submit</c-button>
            <img src="img/brand/sf-logo-mini-white.svg" width="30" class="float-right">
          </div>
          <div class="bg-dark p-4 library-card" v-if="this.$store.getters.isAdmin">
            <h3 class="font-weight-bold">Post a thread</h3>
            <p>Click below to post a clarifying question / or topic of discuss to your customers.</p>
            <c-button size="sm" class="btn-sf btn-square" v-b-modal.post-thread><i class="fal fa-plus"></i> Post</c-button>
            <img src="img/brand/sf-logo-mini-white.svg" width="30" class="float-right">
          </div>
          <knowledgebase-thread-modal modal_id="post-thread" @onSaved="fetch"></knowledgebase-thread-modal>
          <ticket-modal modal_id="thread-ticket"></ticket-modal>
        </c-col>
      </c-row>

    </div>

  </div>
</template>

<script>

import KnowledgebaseThreadModal from "../../../components/tools/faq/KnowledgebaseThreadModal";
import KnowledgebaseThread from "../../../models/KnowledgebaseThread";
import TicketModal from "../../../components/tickets/TicketModal";
export default {
  name: 'KnowledgebaseThreadIndex',
  components: {TicketModal, KnowledgebaseThreadModal},
  data() {
    return {
      threads: null,
      loading: true,
    };
  },
  methods: {
    fetch() {
      this.$refs.loadingProgress.start();
      this.loading = true;
      KnowledgebaseThread.api().fetch().then((response) => {
        this.threads = response.entities[KnowledgebaseThread.entity];
        this.$refs.loadingProgress.done();
        this.loading = false;
      });
    }
  },
  mounted() {
    this.fetch();
  }
}
</script>
